export default __webpack_public_path__ + "static/media/arrow.86e0cc6d.svg";